import { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useMediaQuery } from 'usehooks-ts';
import {
  useDispatch,
  useSelector,
  type TypedUseSelectorHook,
} from 'react-redux';
import { flattenToAppURL } from '@plone/volto/helpers';
import { searchContent } from '@plone/volto/actions/search/search';

import MenuMobile from '@redturtle/qubicaamf-theme/components/Blocks/PageTitleWithMenu/menumobile';
import MenuDesktop from '@redturtle/qubicaamf-theme/components/Blocks/PageTitleWithMenu/menudesktop';
import type { QubicaViewProps, RequestItem } from '../utils';

export interface RootState {
  search: Request & {
    subrequests: {
      parent_items: RequestItem;
    };
  };
}

const ContactFormHeader = (props: QubicaViewProps) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const useTypedSelector: TypedUseSelectorHook<RootState> =
    useSelector<RootState>;
  const { content } = props;
  const isMobile = useMediaQuery('(max-width: 1199px)');

  const parent_title = content.parent.title;
  const parent_id = content.parent['@id'];

  useEffect(() => {
    dispatch(
      searchContent(
        flattenToAppURL(content.parent['@id']),
        {
          portal_type: ['QubicaBaseFolder', 'Document'],
          fullobjects: 1,
        },
        'parent_items',
      ),
    );
  }, [dispatch, content.parent]);

  const siblings = useTypedSelector(
    (state) => state.search.subrequests.parent_items,
  );

  const menuItems = siblings
    ? siblings.items
        .filter((el) => el['@id'] !== flattenToAppURL(content.parent['@id']))
        .map((el) => {
          return {
            title: el.title,
            id: el['@id'],
            active: flattenToAppURL(content['@id']) === el['@id'],
            '@id': el['@id'],
          };
        })
    : [];

  if (menuItems.length > 0) {
    if (isMobile) {
      return (
        <MenuMobile
          items={menuItems}
          id={parent_id}
          title={intl.formatMessage(messages.contact)}
          parent_title={parent_title}
          titleasp={true}
        />
      );
    } else {
      return (
        <MenuDesktop
          items={menuItems}
          isEditMode={false}
          title={intl.formatMessage(messages.contact)}
          parent_title={parent_title}
          titleasp={true}
        />
      );
    }
  }

  return <></>;
};
export default ContactFormHeader;

const messages = defineMessages({
  contact: {
    id: 'contact',
    defaultMessage: 'Contact',
  },
});
